/**!
 * Created by Leonardo Cheslacki on 28/10/2025.
 *
 * MIT License
 *
 * Copyright (c) 2025 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

/**
 * Compiler --min-resources=app
 */
module.exports.path = {
    uri_css: 'css',
    uri_js: 'js',
    uri_img: 'img',
    uri_media: 'media',
    uri_xml: 'xml',
    uri_src: 'src',
    uri_cover: 'capa/capa'
};

module.exports.iframe = {
    size: {
        width: 1920,
        height: 1000,
    },
    attributes: {
        allowfullscreen: '0',
        scrolling: 'no',
        frameborder: '0'
    }
};

module.exports.audio = {
    loop: true,
    all: true
};

module.exports.video = {
    menu_play: true,
    current_time: 0,
    thumbnail_time: 5
};

module.exports.api = {
    ajax_setup_headers: {
        'Authorization': 'Bearer 10|XQ9Fp64YNrPE1I73zEpGdxjy1ZaZHXL6a895fRoZ'
    },
    url: 'http://gerenciador.local/api'
};

module.exports.external = {
    size: {
        width: 800,
        height: 600
    },
    attributes: {
        toolbar: '0',
        location: '0',
        menubar: '0'
    }
};

module.exports.keyboard = {
    delay: 100,
    form: 'auth',
    focus: null,
    submit: false,
    ignore_keys: ['Backspace', 'Space', 'CapsLock', 'ShiftLeft', 'ShiftRight', 'Com', 'Tab', 'Enter'],
    upper_accent_keys: ['key_6', 'key_BracketLeft', 'key_Quote'],
    down_accent_keys: ['key_BracketLeft', 'key_Quote'],
    accent_keys: ['´´', '~~', '¨¨', '``', '^^', '~e', '~i', '~u', '~E', '~I', '~U']
};

module.exports.orientation = {
    speed: 2,
    slide: {
        color_title: '0x606060',
        color_line: '0x606060',
        color_arrow: '0x606060',
        color_round: '0x606060',
        color_circle: '0xE17C2D'
    },
    hours: {
        start: 6,
        end: 18
    },
    stations: [
        {
            month: 1,
            day: null
        },
        {
            month: 2,
            day: null
        },
        {
            month: 3,
            day: 20
        },
        {
            month: 4,
            day: null
        },
        {
            month: 5,
            day: null
        },
        {
            month: 6,
            day: 20
        },
        {
            month: 7,
            day: null
        },
        {
            month: 8,
            day: null
        },
        {
            month: 9,
            day: 22
        },
        {
            month: 10,
            day: null
        },
        {
            month: 11,
            day: null
        },
        {
            month: 12,
            day: 21
        }
    ],
    degrees: {
        autumn: 5,
        winter: 11,
        spring: 5,
        summer: 0
    }
};

module.exports.select = {
    friction: 0.8,
    text: {
        text_x: 140,
        text_y: 45,
        color_enabled: '0x333333',
        color_disabled: '0xAABBC0',
        font_size: 25,
        capitalize: false
    }
};

module.exports.implantation = {
    pin: {
        number_x: null,
        number_y: -7.2,
        color_enabled: '0x000000',
        color_disabled: '0xCCCCCC',
        color_round: '0x38BAA9'
    },
    text: {
        text_x: 140,
        text_y: 38,
        color_number: '0xFFFFFF',
        color_text: '0x606060',
        font_size: 16,
        capitalize: true,
        upper_case: false,
        font_color_same: false
    },
    modal: {
        scale: 0.7,
        composition_name: 'capa',
        padding_vertical: 10,
        padding_horizontal: 7,
        color_text: '0xFFFFFF',
        color_symbol: '0x38BAA9'
    }
};

module.exports.gallery = {
    /**
     * https://github.com/Splidejs/splide
     */
    options: {
        type: 'loop',
        focus: 'center',
        pagination: false,
        perPage: 1,
        arrows: false,
        // legal_warn: 'perspectiva ilustrada'
        // autoplay: true
    },
    styles: {
        zoomFullscreen: {
            zoomBackground: {
                backgroundColor: '#FFFFFF',
                maxWidth: '100vw',
                maxHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: '0 auto',
                position: 'absolute',
                left: '0',
                right: '0',
                top: '0',
                bottom: '0',
                zIndex: '1000'
            },
            zoomImg: {
                maxWidth: '100vw',
                maxHeight: '100vh'
            }
        },
        zoomButton: {
            zoomIcon: {
                width: '30px',
                height: '30px'
            },
            zoomButton: {
                cursor: 'pointer',
                position: 'absolute',
                bottom: '-45px',
                right: '-45px',
                padding: '10px'
            }
        }
    }
};

module.exports._360 = {
    speed: 6,
    slide: {
        color_title: '0xFFFFFF',
        color_line: '0xFFFFFF',
        color_arrow: '0xFFFFFF',
        color_round: '0xFFFFFF',
        color_circle: '0x000000'
    }
};

module.exports.scroll = {
    friction: 0.8,
    pin: {
        number_x: null,
        number_y: -7.2,
        color_enabled: '0x000000',
        color_disabled: '0xCCCCCC',
        color_round: '0xFFFFFF'
    },
    text: {
        text_x: 140,
        text_y: 34,
        color_number: '0xFFFFFF',
        color_text: '0xFFFFFF',
        font_size: 16,
        capitalize: false
    },
    modal: {
        scale: 0.7,
        composition_name: 'capa'
    },
    content_text: {
        frame_01: {
            A: 32
        }
    }
};

module.exports.view = {
    frame: 1,
    pav: 1,
    text: {
        color_text: '0xFFFFFF',
        font_size: 18,
        text_x: null,
        text_y: 5
    }
};

/**
 * Compiler --min-resources=main
 * @param responsive_active Allow replies, 'true' or 'false'.
 * @param responsive_replies Replies by, 'width', 'height' or 'both'.
 * @param scale_active Scale to fill visible area, 'true' or 'false'.
 * @param scale_type Adjust in display 'center' or stretch to fit 'stretch', "1 or 2".
 * @param dom_containers Array containers resize, 'elements'.
 */
module.exports.make = {
    responsive_active: true,
    responsive_replies: 'both',
    scale_active: false,
    scale_type: 1
};
